export { default } from './PageOrLinkTeaser';
